<div class="empty-state-container">
  <div class="empty-state-card">
    <div class="icon-wrapper">
      <div class="icon-pulse"></div>
      <mat-icon class="empty-icon">{{ icon }}</mat-icon>
    </div>

    <h2 class="empty-title">{{ title | translate }}</h2>

    <p *ngIf="description" class="empty-description">
      {{ description | translate }}
    </p>

    <ng-container *ngIf="btnName">
      <a *ngIf="btnLink; else clickBtn" mat-flat-button color="primary" class="empty-action" [routerLink]="btnLink">
        <mat-icon>{{ btnIcon }}</mat-icon>
        <span>{{ btnName | translate }} {{ btnSubName ? (btnSubName | translate) : '' }}</span>
      </a>

      <ng-template #clickBtn>
        <button mat-flat-button color="primary" class="empty-action" (click)="onAction()">
          <mat-icon>{{ btnIcon }}</mat-icon>
          <span>{{ btnName | translate }} {{ btnSubName ? (btnSubName | translate) : '' }}</span>
        </button>
      </ng-template>
    </ng-container>
  </div>
</div>
